module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEXGDDD////sr7vnl6bFCi7FBivDACPAABnGDDD////DACPQOFXFCCzAABjsr7vnl6bsqrfPNFLwvsflkaHOLErLIkK8AAwmO3oTAAAACHRSTlPx8fHx8fHx8aB0vhoAAABtSURBVFjD7dg5EoAgEAVR3GVTcLv/UY0ggIQAq7Cq+wAv+xOMyJrmvgsNyyhKW9OM2mRot2YtDAgICAgICOgfkMqyLkLno0oTOs1fR4Tc7XVhQlYKCKgtqNZEqo22wXsEBAQEBAQE9CFU7X34AhlDq90e4XfyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/buttonCulture/dk.png
// module id = 445
// module chunks = 0